import { cva } from 'cva'

export const buttonWrapperStyle = cva({
  variants: {
    size: {
      xLarge: ['w-[180px]', 'min-h-[52px]'],
      large: ['w-[180px]', 'h-11'],
    },
  },
})

export const buttonStyle = cva({
  base: [
    'inline-flex items-center justify-center whitespace-nowrap font-base ring-offset-white gap-[5px] focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2',
    'select-none [-webkit-touch-callout:none] [-webkit-tap-highlight-color:transparent]',
    'text-gray-900',
    'transform-gpu transition-[transform,box-shadow,background-color,border-color,color] duration-150',
    'border-[1.5px] shadow-[0_4px_0_0] hover:translate-y-1 hover:shadow-none active:translate-y-1 active:shadow-none',
    'disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-300 disabled:shadow-200 disabled:shadow-gray-200 disabled:cursor-not-allowed',
  ],

  variants: {
    variant: {
      primary: [
        'bg-[#B5FD4C]',
        'text-gray-900',
        'border-gray-900',
        'hover:bg-[#9BEB26]',
        'active:bg-[#9BEB26]',
        'shadow-gray-900',
      ],
      ghost: [
        'bg-white',
        'hover:bg-gray-50',
        'border-gray-200',
        'hover:bg-gray-100',
        'active:bg-gray-100',
        'shadow-gray-200',
      ],
      warn: [
        'bg-white',
        'text-red-500',
        'border-gray-200',
        'hover:bg-gray-100',
        'active:bg-gray-100',
        'shadow-gray-200',
      ],
      // ! 디자인 시스템의 warn 색상과 일치하지 않는 부분이 있어 warning 으로 임시 정의한것
      warning: [
        'bg-[#FD6771]',
        'text-white',
        'border-gray-900',
        'hover:bg-[#fc525e]',
        'active:bg-[#fc525e]',
        'shadow-gray-900',
      ],
      blue: [
        'bg-[#6184FF]',
        'text-white',
        'border-gray-900',
        'hover:bg-[#4A6FE8]',
        'active:bg-[#4A6FE8]',
        'shadow-gray-900',
      ],
    },
    size: {
      xLarge: ['w-[180px]', 'min-h-12', 'text-xl'],
      large: ['w-[180px]', 'h-10', 'text-md'],
    },
    shape: {
      round: ['rounded-[5px]'],
      square: ['rounded-[12px]'],
    },
  },

  defaultVariants: {
    variant: 'primary',
    size: 'xLarge',
    shape: 'square',
  },
})
